export default __webpack_public_path__ + "static/jira-screen-new-styles-fb273e94e629d50d5d3885d03ecb5624.png";